import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col } from 'react-bootstrap';
import ReactSwitch from 'react-switch';

class CheckField extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    const extraProps = Object.keys(this.props).includes('extraProps') ? this.props.extraProps : {
      onText: <i className='fa fa-check' />
    };
    return (
      <>
        <ReactSwitch
          onColor='#3fdf2b'
          onHandleColor='#19970a'
          handleDiameter={(this.props.height || 15) / 1.2}
          uncheckedIcon={false}
          checkedIcon
          boxShadow='0px 1px 5px rgba(0, 0, 0, 0.6)'
          // activeBoxShadow='0px 0px 1px 10px rgba(0, 0, 0, 0.2)'
          onChange={v => this.props.setValue(v)}
          checked={this.props.value}
          height={this.props.height || 15}
          width={this.props.width || 30}
          {...extraProps}
        />

      </>
    );
  }
}

export default CheckField;
